export default "__VITE_ASSET__D9jxeV3F__"